const dataInicialElement = document.querySelector('#dataInicial');
const dataFinalElement = document.querySelector('#dataFinal');
const moedaElement = document.querySelector('#moeda');
const statusElement = document.querySelector('#status');

const formFilter = document.querySelector('#form-filter');

class DashboardTables {

  static url = /^\/admin\/dashboard-graficos/g;

  static init () {
    DashboardTables.dashboardTables = new DashboardTables();
    return window.dashboardTables;
  }

  constructor () {
    this.addEventListener();
    this.loadInfo();
  }

  addEventListener () {
    formFilter.addEventListener('submit', (e) => {
      e.preventDefault();
      this.loadInfo();
    })
  }

  getFormData () {
    const status = statusElement.selectize;
    const data = new FormData();
    /// a forma de pegar os dados pode estar alterando o valor
    data.append('dataInicial', dataInicialElement.value);
    data.append('dataFinal', dataFinalElement.value);
    data.append('idMoeda', moedaElement.value);
    status.getValue().forEach((index) => {
      data.append('status[]', index);
    });
    return data;
  }

  sendRequest (url) {
    return fetch(route(url), {
      mode: 'no-cors',
      credentials: 'include',
      headers: new Headers({
        'Accept':'application/json'
      }),
      method: 'POST',
      body: new FormData(formFilter)
      // body: new FormData(formFilter)
    });
  }

  getElement (elementIndex) {
    const idElement = '#' + elementIndex.getAttribute('id');
    return  document.querySelector(idElement);
  }

  loadInfo () {
    const infoHolders = document.querySelectorAll('.info-holder');
    const promises = [].map.call(infoHolders, (elementIndex) => {
      return new Promise((resolve, reject) => {
        try {
          const element = this.getElement(elementIndex);
          const urlName = element.getAttribute('data-table-url-name');
          this.sendRequest(urlName)
          .then((response) => {
            if (response.status == 200) {
              response.text()
              .then((text) => {
                element.innerHTML = text;
              })
            }
          })
        } catch (e) {
          reject(e);
        }
        resolve();
      });
    });
    Promise.all(promises);
  }
}

export default DashboardTables;
